import React, { useState, useEffect } from "react";
import {
  StyledIcon,
  StyledIconContainer,
} from "../../home/components/slider/advertisement/AdvertisementCardStyles";
import ItemsCarousel from "react-items-carousel";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import styled from "styled-components";
import { Box, colors, Grid } from "@material-ui/core";
import { ProductListProps } from "./ProductList";
import AnnualProductCard from "./AnnualProductCard";
import ProductCard from "./ProductCard";
import { StyledBoxContainer } from "./StyledComponent";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import Colors from "../../../common/materials/colors";

const IconCircle = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "2px solid",
  borderRadius: "50%",
  color: Colors.red,
  borderColor: Colors.red,
  width: "40px",
  height: "40px",
  cursor: "pointer",
});

const FeaturedProductsCarousel = (props: ProductListProps) => {
  console.log(props.productsList);
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 40;
  const { hideBidButton, fixedHeightCards, isZipang, isLandingPage, isMobile } =
    props;
  let numberOfCardsCount = isMobile ? 1 : 3;

  const theme = useTheme();
  const isExtraSmallDevice = useMediaQuery(theme.breakpoints.down("xs"));
  const isSmallDevice = useMediaQuery(theme.breakpoints.between("xs", "sm"));
  const isMediumDevice = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLargeDevice = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isExtraLargeDevice = useMediaQuery(
    theme.breakpoints.between("lg", "xl")
  );

  if (isExtraSmallDevice) {
    numberOfCardsCount = 1;
  } else if (isSmallDevice) {
    numberOfCardsCount = 1;
  } else if (isMediumDevice) {
    numberOfCardsCount = 2;
  } else if (isLargeDevice) {
    numberOfCardsCount = 3;
  } else if (isExtraLargeDevice) {
    numberOfCardsCount = 3;
  }

  // 🟢 Auto-scroll logic (added)
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveItemIndex((prevIndex) => {
        const nextIndex = prevIndex + numberOfCardsCount;
        if (nextIndex >= props.productsList.length) {
          return 0; // loop back to start
        }
        return nextIndex;
      });
    }, 3000); // scroll every 3 seconds

    return () => clearInterval(interval);
  }, [numberOfCardsCount, props.productsList.length]);

  const PrevButton = () => (
    <IconCircle>
      <ArrowBackIcon />
    </IconCircle>
  );

  const NextButton = () => (
    <IconCircle>
      <ArrowForwardIcon />
    </IconCircle>
  );

  return (
    <div
      style={{
        width: "100%",
        position: "relative",
        padding: `0 ${chevronWidth + 20}px`, // <-- add extra padding for spacing
      }}
    >
      <ItemsCarousel
        requestToChangeActive={setActiveItemIndex}
        activeItemIndex={activeItemIndex}
        numberOfCards={numberOfCardsCount}
        slidesToScroll={numberOfCardsCount}
        leftChevron={
          <div style={{ marginRight: 40 }}>
            <PrevButton />
          </div>
        }
        rightChevron={
          <div style={{ marginLeft: 40 }}>
            <NextButton />
          </div>
        }
        chevronWidth={chevronWidth}
        infiniteLoop={false}
        gutter={10}
        outsideChevron
      >
        {props.productsList.slice(0, 50).map((product: any, index: number) => {
          return (
            <>
              {isZipang ? (
                <AnnualProductCard
                  hideBidButton={hideBidButton}
                  key={product.productId}
                  {...product}
                  fixedHeightCards={true}
                  isZipang={isZipang}
                  isLandingPage={isLandingPage}
                  carouselMode={true}
                />
              ) : (
                <ProductCard
                  hideBidButton={hideBidButton}
                  key={product.productId}
                  {...product}
                  fixedHeightCards={true}
                  isZipang={isZipang}
                />
              )}
            </>
          );
        })}
      </ItemsCarousel>
    </div>
  );
};

export default FeaturedProductsCarousel;
